import React from 'react';

import { Desktop, Mobile } from '../Common/const';
import RichText from '../Common/RichText/RichText';

class FurtherReading extends React.Component {
  handleClick = () => {
    if (this.props.disabled) {
      if (this.props.onDisabledClick) this.props.onDisabledClick();
    } else if (this.props.pdfUrl !== '') {
      this.props.getPdfByReference(this.props.pdfUrl);
    }
  };

  openPdfViewer = () => {
    if (this.props.disabled) {
      if (this.props.onDisabledClick) this.props.onDisabledClick();
    } else if (this.props.pdfUrl && this.props.pdfUrl !== '') {
      this.props.getPdfByReference(this.props.pdfUrl);
      this.props.openPdfViewer();
    }
  };

  render() {
    return (
      <div className="row reference mr-4">
        <div className="col-12 mb-1">
          <h4>Further Reading</h4>
          <RichText tag="p" html={this.props.notes} />
          <Desktop>
            <div
              className="card card-reference pointer"
              onClick={this.openPdfViewer}
            >
              <p className="m-0 eye">
                <i
                  className={
                    this.props.pdfUrl !== '' && this.props.pdfUrl !== null
                      ? 'icon icon-eye2'
                      : 'icon icon-eye2 disabled'
                  }
                />
              </p>
              <div className="card-body">
                <h5>REFERENCE</h5>
                <h4>{this.props.reference}</h4>
                <p
                  className={
                    this.props.pdfUrl !== '' && this.props.pdfUrl !== null
                      ? 'bottom-link'
                      : 'bottom-link disabled'
                  }
                >
                  View reference
                </p>
              </div>
            </div>
          </Desktop>
          <Mobile>
            <div
              className="card card-reference pointer"
              onClick={this.handleClick}
            >
              <p className="m-0 eye">
                <i
                  className={
                    this.props.pdfUrl !== '' && this.props.pdfUrl !== null
                      ? 'icon icon-eye2'
                      : 'icon icon-eye2 disabled'
                  }
                />
              </p>
              <div className="card-body">
                <h5>REFERENCE</h5>
                <h4>{this.props.reference}</h4>
                <p
                  className={
                    this.props.pdfUrl !== '' && this.props.pdfUrl !== null
                      ? 'bottom-link'
                      : 'bottom-link disabled'
                  }
                >
                  View reference
                </p>
              </div>
            </div>
          </Mobile>
        </div>
      </div>
    );
  }
}

export default FurtherReading;
